'use client'

import dynamic from 'next/dynamic'

import '@/components/LandingPage/ContentModel/Layout/Menu/Menu.scss'

const MenuLogic = dynamic(() => import('@/components/LandingPage/ContentModel/Layout/Menu/MenuLogic'), {
  ssr: false,
})

export default function Menu({ selectionNames }: { selectionNames: string[] }) {
  return (
    <>
      <MenuLogic selectionNames={selectionNames} />
    </>
  )
}
